const findCharacter = (str: any) => {
  const chars = /[a-zA-Z~`!#$%^&*+=\-[\]\\';,/{}|\\":<>?]/;
  return chars.test(str);
};

function formatBengaliNumber(input: any): string {
  const bengaliNumerals = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯'];

  const yearString = input.toString();
  const parts = yearString.split(','); // Split by commas

  let formattedNumber = '';

  // eslint-disable-next-line no-restricted-syntax
  for (const part of parts) {
    for (let i = 0; i < part.length; i++) {
      // If there is any character, then add it as it is to the formattedNumber variable
      if (findCharacter(part[i])) {
        formattedNumber += part[i];
      } else {
        const digit = parseInt(part[i], 10);
        formattedNumber += bengaliNumerals[digit];
      }
    }
    formattedNumber += ','; // Add comma after each part
  }

  formattedNumber = formattedNumber.slice(0, -1); // Remove last comma

  return formattedNumber;
}

export default formatBengaliNumber;
